import ability from "./ability";

export const canNavigate = to =>
  to.matched.some(route => {
    const actions = Array.isArray(route.meta.action) ? route.meta.action : [route.meta.action || "view"];
    return actions.some(action => ability.can(action, route.meta.resource.toLowerCase()));
  });

export const _ = undefined;
